<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-partners-hero-section />
  <!-- Benefits -->
  <app-partners-benefits-section />
  <!-- FAQ -->
  <app-partners-faq-section />
  <!-- CTA -->
  <app-partners-cta-section />
</div>
